module.exports = __webpack_public_path__ + "img/Extruder.ae154698.svg";